<template>
  <div v-show="innerValue" class="fullscreen-panel" ref="printWindow">
    <v-card rounded="0" flat>
      <div class="elevation-3 primary d-print-none">
        <v-container class="px-0">
          <dialog-title
            :title="title"
            class="white--text pl-md-0"
            v-model="innerValue"
          >
            <template v-slot:actions="{ close }">
              <v-btn fab small class="mr-2" @click="print">
                <v-icon>$print</v-icon></v-btn
              >
              <v-btn fab small @click="close"> <v-icon>$close</v-icon></v-btn>
            </template>
          </dialog-title>
        </v-container>
      </div>
      <v-container class="px-0">
        <slot></slot>
      </v-container>
    </v-card>
  </div>
</template>

<style>
@media print {
  thead {
    display: table-header-group;
  }
  tfoot {
    display: table-footer-group;
  }

  body {
    margin: 0;
  }
}

.print-page {
  page-break-after: always;
}

.fullscreen-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
}

.print-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.print-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

<script>
import DialogTitle from "../../components/DialogTitle.vue";

export default {
  name: "PrintWindow",
  components: { DialogTitle },
  props: {
    value: Boolean,
    title: String,
  },
  data: () => ({
    innerValue: false,
    appWrap: null,
    appHeader: null,
    main: null,
    moved: false,
  }),
  watch: {
    value(val, prev) {
      if (val != prev) this.innerValue = !!val;
    },
    innerValue(val, prev) {
      if (val != prev) this.$emit("input", !!val);

      if (val) {
        this.$el.parentNode.removeChild(this.$el);
        this.appWrap.appendChild(this.$el);
        this.appHeader.classList.add('d-none')

        setTimeout(this.print, 500);
      } else {
        // Place the element back at its original location.
        this.originalParentNode.appendChild(this.$el);
        this.appHeader.classList.remove('d-none')
      }
    },
  },
  methods: {
    print() {
      window.print();
    },
  },
  mounted() {
    this.appWrap = document.querySelector(".v-application--wrap");
    this.appHeader = document.querySelector(".v-app-bar");
    this.originalParentNode = this.$el.parentNode;
    if (this.value) this.innerValue = !!this.value;
  },
};
</script>